module.exports = __webpack_public_path__ + "img/amkalogo_full.a2a4949a.svg";